<template>
	<div class="Browse">
		<div class="Browse-wrapper">
			<!-- Top Bar -->
<!--			<section class="Browse-topbar hidden-xs">
				<div class="row">
					<div class="col-md-12">
						<button class="btn btn-primary" @click="goUp()" :disabled="disabledUp()">Up</button>
						<button class="btn btn-primary" @click="handleCreateFolder()">Create Folder</button>
						<button type="button" class="btn btn-primary" @click="showUploadModal()">Upload File</button>
					</div>
				</div>
			</section>-->

			<!-- Content -->
			<section class="Browse-content">
<!--			<div class="Browse-content-mobileTop visible-xs">

					<ol class="breadcrumb">
						<li><a href="" @click.prevent="handleMobilePathClick"><i class="fa fa-bars"></i></a></li>
						<li v-for="pathPart in breadcrumbPath">{{pathPart}}</li>
					</ol>
					<div class="Browse-fileListMobile" v-if="isMobileFileBrowserVisible">
						<div class="Browse-fileListMobile-wrapper">
							<section class="Browse-mobileTopBar">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary" @click="goUp()" :disabled="disabledUp()">Up
										</button>
										<button class="btn btn-primary" @click="handleCreateFolder()">Create Folder
										</button>
										<button type="button" class="btn btn-primary" @click="showUploadModal()">Upload
											File
										</button>
									</div>
								</div>
							</section>
							<FileList
								:folders="folders"
								:files="files"
								:goToFolder="goToFolder"
								:handleMetadataClick="handleMetadataClick"
								:handleDelete="handleDelete"
							/>
						</div>
					</div>
				</div>-->
<!--				<div class="Browse-fileList hidden-xs">
					<FileList
						:folders="folders"
						:files="files"
						:goToFolder="goToFolder"
						:handleMetadataClick="handleMetadataClick"
						:handleDelete="handleDelete"
					/>
				</div>-->
				<div class="Browse-viewer">
					<toolbar
						:page="page"
						:zoomLevel="zoomLevel"
						:zoomIn="zoomIn"
						:zoomOut="zoomOut"
						:fitTo="fitTo"
						:prevPage="prevPage"
						:nextPage="nextPage"
						:showInks="_showInks"
						:showOverview="_showOverview"
						:showOverprint="_showOverprint"
						:toggleBoxes="_toggleBoxes"
						:toggleRulers="_toggleRulers"
						:set-units="setUnits"></toolbar>
					<pdf
						ref="pdf"
						:url="url"
						:zoom="zoom"
						:page="page"
						:unit="unit"
						:showOverview="showOverview"
						:showInks="showInks"
						:showBoxes="showBoxes"
						:showRulers="showRulers"
						:changePage="changePage"
						:zoomEnd="zoomEnd"
						:showOverprint="showOverprint"/>
					</pdf>
				</div>
			</section>
		</div>
		<div class="modal fade folder-modal" tabindex="-1" role="dialog" id="folder-modal">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
							aria-hidden="true">&times;</span></button>
						<h4 class="modal-title">Upload Files</h4>
					</div>
					<div class="modal-body">
						<form class="form">
							<input type="text" class="form-control" v-model="newFolderName">
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" @click="handleCloseFolderModal()">Cancel</button>
						<button type="button" class="btn btn-primary" @click="createFolder()"
								:disabled="!newFolderName">Create
							Folder
						</button>
					</div>
				</div>
			</div>
		</div>
		<upload @uploadcomplete="uploadComplete" :show="showModal"></upload>
	</div>
</template>
<script type="text/javascript">
	import { mapActions, mapGetters } from 'vuex'
	import axios from 'axios'
	import moment from 'moment'
	import trim from 'lodash/trim';
	import Upload from './Upload.vue'
	import FileList from './FileList.vue';
	import Toolbar from './Toolbar.vue';
	import Pdf from './Pdf.vue';
	export default {
		props: ['url'],
		components: {
			Upload,
			FileList,
			Pdf,
			Toolbar
		},
		created() {
			this.setPath(this.$router.currentRoute.path);
		},
		data() {
			return {
				showInks: false,
				showRulers: true,
				showOverview: true,
				showOverprint: false,
				page: 1,
				zoom: 5,
				zoom100: 5,
				unit: "mm",
				selectedUrl: "",
				newFolderName: "",
				showModal: false,
				showBoxes: false,
				selectedFile: null,
				isMobileFileBrowserVisible: false
			}
		},
		computed: {
			...mapGetters(['item', 'items', 'folders', 'files', 'bases']),
			breadcrumbPath() {
				const path = trim(this.$route.path || '', '/');
				return path.split('/');
			},
			zoomLevel() {
				return Math.pow(2, this.zoom - this.zoom100) * 100;
			}
		},
		methods: {
			...mapActions(['createPath', 'setPath', 'setView']),
			refresh() {
				this.setPath(this.$router.currentRoute.path);
			},
			goUp() {
				const path = this.$router.currentRoute.path
				const parts = path.split("/");
				const newParts = parts.pop();
				const newPath = parts.join("/");
				this.$router.push(newPath);
				this.refresh();
			},
			goToFolder(e, folder) {
				e.preventDefault();
				const parts = JSON.parse(JSON.stringify(folder.path));
				parts.shift();
				this.$router.push(`/browse/${parts.join("/")}`);
				this.refresh();
				return false;
			},
			async selectFile(file) {
				console.log(file);
				file.selected = !file.selected;
				if (this.selectedFile) this.selectedFile = null;
				else this.selectedFile = file;
			},
			isSelected(file) {
				return file.selected;
			},
			handleCreateFolder() {
				$('.folder-modal').modal('show');
			},
			handleCloseFolderModal() {
				$('.folder-modal').modal('hide');
				this.newFolderName = ""
			},
			async createFolder() {
				await this.createPath({
					path: {
						name: this.newFolderName,
						type: "folder"
					},
					parentId: this.item._key
				});
				this.refresh();
				$('.folder-modal').modal('hide');
			},
			async handleCreateFile(name, url) {
				const self = this;
				await self.createPath({
					path: {
						name: name,
						type: "file"
					},
					fileUrl: url,
					parentId: self.item._key
				});
				self.refresh();
			},
			async uploadComplete(data) {
				await this.handleCreateFile(data.file.name, data.uploadUrl);
				this.showModal = false;
			},
			async showUploadModal() {
				this.showModal = true;
			},
			async handleMetadataClick(file) {
				this.selectedFile = file;
				const fileData = await this.$http.get(`${this.bases.fileApi}/files/getdownloadurl/${file.file._key}`);
				this.selectedUrl = fileData.body.url;
				this.isMobileFileBrowserVisible = false;
			},
			async handleDelete(path) {
				const deleteUrl = `${this.bases.fileApi}/paths/${path._key}`;
				const results = await this.$http.delete(deleteUrl);
				this.refresh();
			},
			disabledUp() {
				return this.$router.currentRoute.path.split("/").length < 3;
			},
			formatDate(date) {
				return moment(date).format("DD/M/YYYY h:mm:ss");
			},
			handleMobilePathClick() {
				this.isMobileFileBrowserVisible = !this.isMobileFileBrowserVisible;
			},
			nextPage() {
				this.page++;
			},
			prevPage() {
				if (this.page < 2) return;
				this.page--;
			},
			goToPage(page) {
				this.page = parseInt(page);
			},
			changePage(page) {
				this.page = parseInt(page);
			},
			zoomIn() {
				if (this.zoom < 12) this.zoom = Math.floor(this.zoom + 1);
			},
			zoomOut() {
				if (this.zoom > 1) this.zoom = Math.ceil(this.zoom - 1);
			},
			fitTo(target) {
			  	this.$refs.pdf.fitTo(target)
			},
			zoomEnd(zoom) {
				this.zoom = zoom;
			},
			setUnits(unit) {
				this.unit = unit;
			},
			_showInks() {
				this.showInks = !this.showInks;
			},
			_showOverview() {
				this.showOverview = !this.showOverview;
			},
			_showOverprint() {
				this.showOverprint = !this.showOverprint;
			},
			_toggleBoxes() {
				this.showBoxes = !this.showBoxes;
			},
			_toggleRulers() {
				this.showRulers = !this.showRulers;
			}
		},
		watch: {
			'$route'() {
				this.refresh();
			}
		}
	}

</script>
<style lang="css" scoped>
	.Browse {
		width: 100vw;
		height: 100vh;
	}

	.Browse-wrapper {
		padding: 0 15px;
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.Browse-topbar {
		margin-top: 15px;
		flex-shrink: 1;
	}

	.Browse-content {
		flex-grow: 1;
		margin: 0 -15px;
		display: flex;
		flex-direction: column;
	}

	.Browse-viewer {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}

	@media (min-width: 768px) {
		.Browse-viewer {
			padding: 0 15px;
		}
		.Browse-content {
			flex-direction: row;
		}

		.Browse-fileList {
			width: 25%;
		}

		.Browse-viewer {
			width: 75%;
			padding: 0 15px;
		}
	}

	.Browse-fileListMobile {
		position: relative;
		margin-top: 5px;
	}

	.Browse-fileListMobile-wrapper {
		position: absolute;
		background: white;
		width: 100%;
		z-index: 1000;
		padding: 0 15px;
		box-shadow: rgba(0, 0, 0, 0.2) 0 4px 10px 0px;
	}

	.Browse-content-mobileTop {
		margin: 0 0 5px;
	}

	.Browse-content-mobileTop .breadcrumb {
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// Browse.vue?20af1622